import React, { memo, useMemo } from 'react';
import { Checkbox, Tooltip } from 'antd';
import classNames from 'classnames';
import { AWAssetDto } from '@api/Api';
import Loader from '@components/Loader';
import { assetPreviewThumbnails } from '@helpers/assetPreviewThumbnails';
import { LockIcon } from '@icons';

type NameCellProps = {
  asset: AWAssetDto;
  isSelected: boolean;
  isDisabled: boolean;
  onClick?: (asset: AWAssetDto) => void;
  onSelect: (asset: AWAssetDto) => void;
};

export default memo(function NameCell({
  asset,
  isSelected,
  isDisabled,
  onClick,
  onSelect
}: NameCellProps) {
  const preparePreview = useMemo(() => {
    return assetPreviewThumbnails({
      url: asset?.previewUrl || '',
      status: 'ready',
      type: asset.type,
      size: 40,
      format: 'svg'
    });
  }, [asset]);

  const onOpenAsset = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    if (onClick) onClick(asset);
  };
  return (
    <div
      className={classNames('campaign-approval-table_name-cell', {
        'campaign-approval-table_name-cell--disabled': asset.accessDisabled
      })}
    >
      <div
        className={classNames('campaign-approval-table_name-cell-checkbox', {
          'campaign-approval-table_name-cell-checkbox--disabled': isDisabled
        })}
        onClick={(e) => {
          if (isDisabled) return;
          e.stopPropagation();
          onSelect(asset);
        }}
      >
        <Checkbox
          value={asset?.id}
          disabled={isDisabled}
          checked={isSelected}
          onChange={() => onSelect(asset)}
          onClick={(e) => e.stopPropagation()}
        />
      </div>
      <div
        className="campaign-approval-table_name-cell-info"
        onClick={onOpenAsset}
      >
        <div className="campaign-approval-table_name-cell-image">
          <div className="campaign-approval-table_name-cell-lock-icon">
            <LockIcon />
          </div>
          {preparePreview === 'pending' && (
            <Loader spinSize={40} isSpinning={true} />
          )}
          {preparePreview !== 'pending' &&
          typeof preparePreview === 'string' ? (
            <img src={preparePreview || ''} alt="" />
          ) : (
            preparePreview
          )}
        </div>
        <div className="campaign-approval-table_name-cell-title">
          <div className="campaign-approval-table_name-cell-name">
            <Tooltip
              title={
                asset.accessDisabled
                  ? 'Your access to this media is restricted. Contact the approval manager if you need to request access.'
                  : asset.name
              }
              overlayClassName="toggle_favorite_overlay"
              className="b-asset-name"
              placement="topLeft"
            >
              <div>{asset.name}</div>
            </Tooltip>
            <span>.{asset.extension}</span>
          </div>
          <div className="campaign-approval-table_name-cell-version">
            V{asset.versionsCount}
          </div>
        </div>
      </div>
    </div>
  );
});
